<ng-container *ngIf="initialized">
    <mvs-crud-object-generic
            [objectType]="'tm.Ticket'"
            [objectId]="ticketDto.id"
            [defaultCreateDto]="createDefaultDto"
            [formControlOverwrite]="formControlOverwrite"
            [disabled]="ticketActionsList?.length > 0"
            [askForConfirmation]="true"
            (onChangedObject)="handleObjectChange($event)"
            (beforeSaveCallback)="handleBeforeSaveCallback($event)"
    ></mvs-crud-object-generic>

    <p-messages
            *ngIf="availableActionsResponse && availableActionsResponse.availableActions?.length && ticketActionsList?.length > 0"
            severity="error">
           Folgende Aktionen müssen noch abgeschlossen werden
    </p-messages>

    <tm-ticket-actions
            *ngIf="availableActionsResponse && ticketActionsList?.length > 0"
            class="mt-3 block"
            [addActions]="false"
            [ticketId]="ticketDto.id"
            [ticketActionsList]="ticketActionsList"
            [processMode]="false"
            [availableActionsResponse]="availableActionsResponse"
            (onAddTicketAction)="handleAddTicketAction($event)"
            (onInitiateProcess)="handleInitiateProcess($event)"
            (onActionStatusChange)="handleStatusChange($event)"
    >
    </tm-ticket-actions>
</ng-container>